export const ContactConfig = {
  contactItems: [
    { id: "email", icon: "envelope-o", text: "gonzalo@opseeker.com" },
    { id: "phone", icon: "phone", text: " +34 638 47 35 34" },
    {
      id: "address",
      icon: "map-marker",
      text: "Rua das Hedras, 6 1F 15895 Ames (A Coruña), Spain"
    }
  ],
  socialMedia: [
    { id: "facebook", url: "https://www.facebook.com/OpSeeker/" },
    { id: "instagram", url: "https://www.instagram.com/opseeker/" },
    { id: "twitter", url: "https://twitter.com/opseekerfin/" }
  ]
};

export default ContactConfig;



// WEBPACK FOOTER //
// ./src/containers/contact/ContactConfig.js